import React from "react";

const CustomComma: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="31"
            height="25"
            fill="none"
            viewBox="0 0 31 25"
            role="presentation"
        >
            <path
                fill="#323132"
                d="M0 24.287v-8.1c0-3 .5-5.8 1.5-8.4 1.067-2.6 2.867-5.166 5.4-7.7l4.5 3.5c-2 2-3.367 3.867-4.1 5.6-.667 1.734-1 3.534-1 5.4l-2.8-2.2h8.4v11.9H0zm18.2 0v-8.1c0-3 .5-5.8 1.5-8.4 1.067-2.6 2.867-5.166 5.4-7.7l4.5 3.5c-2 2-3.367 3.867-4.1 5.6-.667 1.734-1 3.534-1 5.4l-2.8-2.2h8.4v11.9H18.2z"
            ></path>
        </svg>
    );
};

export default React.memo(CustomComma);
